export default {
  init () {
    const self = this;
    this.initNightexpressInputs();
    this.initUserTypeToggle();

    $(document).ready(function() {
      if($('#place_order')) {
        var buttonText = $('#place_order').data('value');
        var iconHtml = '<i class="icon icon-arrow-right" style="margin-left: 10px;"></i>';
        $('#place_order').html(buttonText + iconHtml);
      }
      self.updateColspans();
    });

    $('body').on('updated_checkout', function(){
      console.log('updated_checkout triggered');
      self.updateColspans();
      // Re-initialize user type toggle after checkout update
      // Use setTimeout to ensure DOM is fully updated
      setTimeout(function() {
        self.initUserTypeToggle();
      }, 100);
    });

    $('body').on('change', '#shipping_time_week, #shipping_time_day, #shipping_time_night, #shipping_time_winter', event => {
      // Prevent multiple simultaneous submissions
      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;

      // Uncheck other radio buttons
      $('#shipping_time_week, #shipping_time_day, #shipping_time_night, #shipping_time_winter')
        .not(event.target)
        .prop('checked', false);

      const isNightExpress = event.target.id == 'shipping_time_night';

      // Prepare night express data
      let nightexpress = [];
      if (isNightExpress) {
        this.initNightexpressInputs();
        $('.js-night-express-options').show();
      } else {
        $('.js-night-express-options').hide();
      }

      // Single consolidated AJAX call
      $.ajax({
        type: 'POST',
        url: admin_url.ajax_url,
        data: {
          action: 'hr_cart_update_express_status',
          shipping_option: event.target.id,
          night_express: nightexpress,
          update_night_express: true // Flag to handle both operations server-side
        },
        success: (response) => {
          $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');

          // Single checkout update
          $('body').trigger('update_checkout');
          $('body').trigger('updated_shipping_method');
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          alert(errorThrown);
        },
        complete: () => {
          this.isUpdating = false;
        }
      });
    });
  },

  initNightexpressInputs () {
    $('body').on('change', '.js-night-express-options input[type=checkbox]', event => {
      event.stopImmediatePropagation();

      if (this.isUpdating) {
        return;
      }
      this.isUpdating = true;

      let $express_options = $('.js-night-express-options input[type=checkbox]:checked');
      let nightexpress = [];

      $express_options.each(function(i, item){
        let obj = {};
        obj[item.name] = item.value;
        nightexpress.push(obj);
      });

      // Single AJAX call for night express options
      $.ajax({
        type: 'POST',
        url: admin_url.ajax_url,
        data: {
          action: 'add_night_express',
          nightexpress: nightexpress,
        },
        success: (data) => {
          $('form[name="checkout"] input[name*="shipping_method"]').trigger('change');
          $('body').trigger('update_checkout');
          $('body').trigger('updated_shipping_method');
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          alert(errorThrown);
        },
        complete: () => {
          this.isUpdating = false;
        }
      });
    });
  },

  updateColspans () {
    if ($(window).width() < 768) {
      $('.cart-custom-shipping, .woocommerce-shipping-totals').each(function() {
        $(this).find('td:nth-child(2)').attr('colspan', '3');
      });
      $('.headline-row').each(function() {
        $(this).find('td:nth-child(2)').attr('colspan', '4');
      });
    }
  },

  initUserTypeToggle () {
    // Conditional required fields for company checkout
    const $userTypeSelect = $('#user-type-select');
    const $userTypeSelectParent = $userTypeSelect.closest('p.woocommerce-FormRow');
    let $companyFieldsContainer = $('.company_fields');

    // Only proceed if user type select exists and has a parent (DOM is ready)
    if (!$userTypeSelect.length || !$userTypeSelectParent.length) {
      return;
    }

    // Don't run if billing fields wrapper is empty (AJAX in progress)
    const $billingWrapper = $('.woocommerce-billing-fields__field-wrapper');
    if ($billingWrapper.length && $billingWrapper.children().length === 0) {
      return;
    }

    // Ensure company_fields container exists and is positioned AFTER the user type select
    if (!$companyFieldsContainer.length) {
      $companyFieldsContainer = $('<div class="company_fields"></div>');
      $userTypeSelectParent.after($companyFieldsContainer);
    } else {
      // Check if container needs to be repositioned
      const $prev = $companyFieldsContainer.prev();
      if ($prev.length === 0 || $prev[0] !== $userTypeSelectParent[0]) {
        // Move container to be right after user type select if it's not already
        $companyFieldsContainer.insertAfter($userTypeSelectParent);
      }
    }

    // Find company and VAT fields in their original positions
    const $companyField = $('#billing_company_field');
    const $vatField = $('#woocommerce_eu_vat_number_field, #billing_vat_number_field').first();

    // Move fields into company_fields container if they exist and aren't already there
    if ($companyField.length && !$companyField.parent().hasClass('company_fields')) {
      // Detach from original position and append to container
      $companyField.detach().appendTo($companyFieldsContainer);
    }
    if ($vatField.length && !$vatField.parent().hasClass('company_fields')) {
      // Detach from original position and append to container
      $vatField.detach().appendTo($companyFieldsContainer);
    }

    const $companyInput = $('#billing_company');
    const $vatInput = $('#billing_vat_number, #woocommerce_eu_vat_number').first();

    function toggleCompanyFields(clearValues = false) {
      const userType = $userTypeSelect.val();

      if (userType === 'company') {
        $companyFieldsContainer.show();
        // Add required attribute
        $companyInput.prop('required', true);
        $vatInput.prop('required', true);
        // Add visual asterisk to labels if not present
        $companyFieldsContainer.find('label').each(function() {
          const $label = $(this);
          if ($label.find('.required, .optional').length === 0) {
            $label.append('&nbsp;<abbr class="required" title="required">*</abbr>');
          } else {
            // Replace (optional) with required asterisk
            $label.find('.optional').replaceWith('<abbr class="required" title="required">*</abbr>');
          }
        });
      } else {
        $companyFieldsContainer.hide();
        // Remove required attribute
        $companyInput.prop('required', false);
        $vatInput.prop('required', false);
        // Only clear values if explicitly requested (user changed selection)
        if (clearValues) {
          $companyInput.val('');
          $vatInput.val('');
        }
      }
    }

    // Initialize toggle on page load (don't clear values)
    toggleCompanyFields(false);

    // Update on change - remove existing handler first to prevent duplicates
    $userTypeSelect.off('change.usertype');
    $userTypeSelect.on('change.usertype', function() {
      // Clear values when user explicitly changes selection
      toggleCompanyFields(true);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js